import React, {Fragment} from "react";

const PanelWrapperNull = ({ title, help_text, children }) =>
{
    return (
        <Fragment>
            {children}
        </Fragment>
    )
}
export default PanelWrapperNull;